<div class="contenedor-principal-noticia">

    <div class="spacer5" id="tpid"></div>
    <div class="spacer2"></div>

    <div class="contenedor-medida-noticia" name="arriba" *ngIf="noticiaElegida">
        <!--titulo noticia-->
        <div class="spacer10negro">
            <div class="contenedor-texto-titulo">
                <div class="texto-titulo">
                    <div class="contenedor-centrear">
                        <div class="centrado-texto">
                            <p class="noticia">{{noticiaElegida.title}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Fin titulo noticia-->

        <!--Inicio contenedor noticia-->
        <div class="contenedor-descripcion">
            <div class="row rowaux">
                <div class="col-12 col-lg-9 colaux">
                    <div class="contenedor-img-descripcion">
                        <img src="{{noticiaElegida.image}}" alt="">
                    </div>
                    <div class="contenedor-texto-descripcion">
                        <div class="contenedor-titulo">
                            <p> Fuente: {{ noticiaElegida.source }} </p>
                            <p class="noticia">Cochabamba,
                                {{noticiaElegida.dateOfNew.toDate().getDate()}}/{{noticiaElegida.dateOfNew.toDate().getMonth() + 1}}/{{noticiaElegida.dateOfNew.toDate().getFullYear()}}
                            </p>
                            <p class="noticia">{{noticiaElegida.category.name}}</p>
                        </div>
                        <div class="descripcion-noticia-completa">
                            <p class="noticia">
                                {{noticiaElegida.description}}
                            </p>
                        </div>
                    </div>
                </div>

                <!--Inicio seccion botones-->
                <div class="btnBack2">
                    <a target="_blank" href="{{base}}" (click)="toFb(noticiaElegida.id)">
                        <button mat-stroked-button class="btn-primaryfb">
                            <div class="fb-share-button" [attr.data-href]="base2" data-layout="button"
                                data-size="small">
                                <i class="fa fa-facebook-square" style="font-size:35px;color:#3B5998"></i>
                            </div>
                        </button>
                    </a>
                </div>
                <div class="btnBack">
                    <button mat-mini-fab color="warn" routerLink="/noticias">
                        <mat-icon class="colorPublish">reply</mat-icon>
                    </button>
                </div>

                <div class="btnTop">
                    <button mat-mini-fab color="warn" (click)="ScrollTo()">
                        <mat-icon class="colorPublish">keyboard_arrow_up</mat-icon>
                    </button>
                </div>
                <!--Fin seccion botones-->

                <!--Inicio sugerencias-->
                <div class="col-12 col-lg-3 colaux colauxVisible">
                    <div class="titulo-sugerencias">SUGERENCIAS</div>
                    <div class="col-12  example-container mat-elevation-z8">
                        <table mat-table [dataSource]="datasourcenew">
                            <ng-container matColumnDef="id" sticky>
                                <th mat-header-cell *matHeaderCellDef> </th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="sugerencias-image" (click)="cambiar(element.id);">
                                        <div class="contenedor-image-centrar">
                                            <img class="col-12" src="{{element.image}}" alt="">
                                            <div class="centrear-image-sugerencias">
                                                <div class="contenedor-texto-sugerencias"
                                                    [ngClass]="{'contenedor-texto-sugerenciasB': noticiaElegida.id == element.id }">
                                                    <div class="centrear-texto-sugerencias">
                                                        <p>{{element.autor | truncate:'30'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                            <div class="row">
                            </div>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>
                </div>
                <!--Fin sugerencias-->
            </div>
        </div>
        <!--Fin contendor noticias-->

        <!--Boton compartir-->
        <div class="btnEnd">
            <a target="_blank" href="{{base}}" (click)="toFb(noticiaElegida.id)" id="facebook-Link">
                <button mat-stroked-button class="btn-primaryfb">
                    <div class="fb-share-button" [attr.data-href]="base2" data-layout="button" data-size="small">

                        <i class="fa fa-facebook-square" style="font-size:35px;color:#3B5998"></i>
                    </div>
                </button>
            </a>


        </div>
        <!--Fin boton compartir-->

        <!--Inicio Sugerencias responsivo-->
        <div class="news-recommend invi991">
            <div class="carruselcontent2">
                <div class="contentcarruselbox">
                    <div class="titulo-categorias">
                        <h3>Sugerencias</h3>
                    </div>
                    <div class="contenedor-principal">
                        <app-sugest-slider style="width: 100%" [noticias]="datasourcenew" (openNotiSel)="cambiar($event)"></app-sugest-slider>
                    </div>
                </div>
            </div>
        </div>

        <!--
        <p class="grandText">SUGERENCIAS</p>
        <div class="grandparent">
            <div class="parent">
                <div *ngFor="let sugerencia of datasourcenew" class="child" (click)="cambiar(sugerencia.id); ">
                    <img class="imgBarra" src="{{sugerencia.image}}" alt="">
                    <div class="bottomed">
                        <div class="contenedor-texto-sugerencias textoSugerencia"
                            [ngClass]="{'contenedor-texto-sugerenciasB': noticiaElegida.id  == sugerencia.id }">
                            <p class="titleSugerencia">{{sugerencia.autor}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="grandparent">
            <div class="parent2" *ngIf="datasourcenew">
                <div *ngFor="let sugerencia of datasourcenew" class="child2" (click)="cambiar(sugerencia.id);">
                    <img class="imgBarra2" src="{{sugerencia.image}}" alt="">
                    <div class="bottomed2">
                        <div class="contenedor-texto-sugerencias"
                            [ngClass]="{'contenedor-texto-sugerenciasB': noticiaActual.id == sugerencia.id }">
                            <p class="txtsugerencias">{{sugerencia.autor}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        -->
        <!--Fin Sugerencias responsivo-->
    </div>

    <app-publicidad></app-publicidad>
</div>
<app-footernd></app-footernd>
